import {apiUrls} from "../../constants/apiUrls";
import apiCall from "../../utils/apiCall";
import {UserCreate,  UserUpdate} from "../../types/api/authorization/user.types";

export const userService = {

    getUsersByUserIds: async (ids: Array<string | { userId?: string }>) => {
        const params = new URLSearchParams();

        ids.forEach((id) => {
            const userId = typeof id === "string" ? id : id.userId;
            if (userId) {
                params.append("usersIds", userId);
            }
        });

        return apiCall.get(
            `${apiUrls.authorization.user.getUsersByUserIds}?${params.toString()}`
        );
    },

    create: (user: UserCreate) =>
        apiCall.post(apiUrls.authorization.user.create, user),

    update: (user: UserUpdate) =>
        apiCall.post(apiUrls.authorization.user.update, user),

    getAllFullInfoUser: () =>
        apiCall.get(apiUrls.authorization.user.getAllFullInfoUser),
}